module.exports = {
    props: ['team', 'invitations'],

    /**
     * The component's data.
     */
    data() {
        return {
            resending: {}
        };
    },

    methods: {
        /**
         * Resend the invitation email.
         */
        resend(invitation) {
            this.$set(this.resending, invitation.id, true);

            axios.post(`/settings/invitations/${invitation.id}/resend`)
                .then(() => {
                    this.$set(this.resending, invitation.id, false);
                })
                .catch(() => {
                    this.$set(this.resending, invitation.id, false);
                });
        },

        /**
         * Cancel the sent invitation.
         */
        cancel(invitation) {
            axios.delete(`/settings/invitations/${invitation.id}`)
                .then(() => {
                    this.$parent.$emit('updateInvitations');
                });
        }
    }
};
